import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import * as styles from './Control.scss';

var Control = /*#__PURE__*/function (_Component) {
  _inherits(Control, _Component);

  var _super = _createSuper(Control);

  function Control() {
    var _this;

    _classCallCheck(this, Control);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      if (!_this.props.disabled) {
        _this.props.onClick();
      }
    });

    return _this;
  }

  _createClass(Control, [{
    key: "render",
    value:
    /** ********************************************************************************************
     RENDER METHODS
    ************************************************************************************************/
    function render() {
      var _this$props = this.props,
          iconName = _this$props.iconName,
          style = _this$props.style,
          text = _this$props.text,
          type = _this$props.type,
          className = _this$props.className;
      var disabledStyle = this.props.disabled ? {
        opacity: 0.65
      } : {};
      var innerStyle = Object.assign({}, this.props.innerStyle, disabledStyle);
      var innards = /*#__PURE__*/React.createElement("span", {
        style: innerStyle
      }, text);

      if (type === 'icon') {
        innards = /*#__PURE__*/React.createElement("i", {
          className: "icon ".concat(iconName),
          style: innerStyle
        });
      } else if (type === 'checkbox') {
        innards = /*#__PURE__*/React.createElement(Checkbox, {
          iconStyle: {
            height: 44,
            marginRight: 0
          },
          style: innerStyle
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.wrap, " ").concat(className),
        onClick: this.handleClick,
        style: style
      }, innards);
    }
  }]);

  return Control;
}(Component);

_defineProperty(Control, "defaultProps", {
  type: '',
  iconName: '',
  text: '',
  disabled: false,
  onClick: function onClick() {
    return console.log('control clicked');
  },
  innerStyle: {},
  style: {},
  className: ''
});

export default Control;